import React from 'react'
import './player-name-icon.styles.scss';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';

const PlayerNameIcon = ({ player, reverse, hideName, tinyIcon }) => {
  return (
    <div className={`player-name-icon ${reverse ? 'reverse' : ''}`}>
      {
        (player) &&
        <>
          {
            !hideName &&
            (
              <div className='user-name'>
                {player.fName}{player.lName ? ` ${player.lName}` : ''}
              </div>
            )
          }
          <div className='user-icon' >
            <UserIcon profile={player} reverse={true} small={tinyIcon ? false : true} tiny={tinyIcon} />
          </div>
        </>
      }
    </div>
  )
}

export default PlayerNameIcon